import { connect } from "react-redux";
import close_icon from "../../../../assets/icons/close.svg";
import Formulario from "../../../components/Formulario";
import { mapDispatchToProps, mapStateToProps } from "../../../../utils/config";
import { useState } from "react";
import ControllerCadastro from "../../auth/Cadastro/controller";
import ControllerConfiguracoes from "../Home/controller";
import Loading from "../../../components/Loading";
import AlertDialog from "../../../components/AlertDialog";

function AlterarContatoModal({usuario, setUsuario, errors, setErrors, onClose}){
  const [loading, setLoading] = useState(false);
  const [dadosUsuario, setDadosUsuario] = useState({...usuario});
  const [showSuccess, setShowSuccess] = useState(false);

  const controllerCadastro = new ControllerCadastro(dadosUsuario, errors, setDadosUsuario, setErrors, null);
  const controllerConfiguracoes = new ControllerConfiguracoes(usuario, errors, setErrors, setLoading, setUsuario);

  return(
    <div className="modal">
      {loading && <Loading/>}
      {showSuccess && (
        <AlertDialog
          titulo={`Telefone alterado com sucesso!`}
          buttonText={"Ver meus dados"}
          buttonOnClick={onClose}
        />
      )}
      <div className="content-modal">
        <div className="top">
          <h3>Alterar Contato</h3>
          <button type="button" onClick={onClose}>
            <img src={close_icon} alt="Icone de fechar"/>
          </button>
        </div>

        <Formulario id="form-alterar-celular">
          
            <div className="form-group">
              <label htmlFor="celular">Novo celular</label>
              <input type="text" id="celular" name="celular" placeholder="Insira seu novo celular" required autoComplete="off"
                value={dadosUsuario.celular} onChange={(e)=>controllerCadastro.validarCelular(e)} className={errors.celular && 'input-error'}
              />
              <span className="error">{errors.celular}</span> 
            </div>

          <div className="form-group">
            <button type="button" onClick={(e)=>controllerConfiguracoes.alterarDados(e, 'form-alterar-celular', dadosUsuario, setShowSuccess)}>Salvar</button> 
          </div>


              
        </Formulario>
      </div>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(AlterarContatoModal);